module.exports = ".modal-footer {\r\n    text-align: right;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/partials/confirm-delete/confirm-delete.component.css
// module id = ./src/app/pages/partials/confirm-delete/confirm-delete.component.css
// module chunks = main